import React, { useState } from 'react';
import HeaderATS from './HeaderAts';
import FooterAts from './FooterAts';
import { DialogTitle, Radio, RadioGroup } from '@headlessui/react';
import { BellAlertIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import ats from './data';
import DetailingCarousel from './DetailingCarousel';
const pricing = ats.pricing;

      function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }


const Detailing = () => {
    const [frequency, setFrequency] = useState(pricing.frequencies[0]);
    const [open, setOpen] = useState(false);

    return (
        <div>
            <HeaderATS />

            

            <main>
        {/* Showcase section */}
        <div className='mt-8 w-full sm:mt-12 lg:px-8 mb-12'>
        <div className="mx-auto max-w-4xl text-center my-8">
          <p className='text-sm font-semibold leading-6 text-red-600'>{ats.info.name}, LLC</p>
          <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Professional Auto Detailing</h1>
        </div>
        </div>

        {/* Carousel section */}
        <DetailingCarousel />

        {/* Pricing section */}
        <div className="mx-auto mt-8 max-w-7xl px-6 sm:mt-12 lg:px-8 mb-12">
          <div className="mx-auto max-w-4xl text-center">
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-700">Book a service package</h1>
            <p className="mt-3 max-w-5xl text-lg text-gray-600">
              At ATS Auto Detail, we believe a clean car is important for maintaining the value of your vehicle. Checkout or interior and exterior automotive detailing services to keep your car looking and feeling like new.
            </p>
          </div>
          <div className="mt-16 flex justify-center">
            <fieldset aria-label="Payment frequency">
              <RadioGroup
                value={frequency}
                onChange={setFrequency}
                className="grid grid-cols-2 gap-x-1 rounded-sm p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200"
              >
                {pricing.frequencies.map((option) => (
                  <Radio
                    key={option.value}
                    value={option}
                    className="cursor-pointer rounded-sm px-2.5 py-1 text-gray-500 data-[checked]:bg-red-600 data-[checked]:text-white"
                  >
                    {option.label}
                  </Radio>
                ))}
              </RadioGroup>
            </fieldset>
          </div>
          <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-3">
            {pricing.tiers.map((tier) => (
              <div
                key={tier.id}
                className={classNames(
                  tier.mostPopular ? 'ring-2 ring-red-600' : 'ring-1 ring-gray-200',
                  'rounded-sm p-8',
                )}
              >
                <h2
                  id={tier.id}
                  className={classNames(
                    tier.mostPopular ? 'text-red-600' : 'text-gray-900',
                    'text-lg font-semibold leading-8',
                  )}
                >
                  {tier.name}
                </h2>
                <p className="mt-4 text-sm leading-6 text-gray-600">{tier.description}</p>
                <p className="mt-6 flex items-baseline gap-x-1">
                  <span className="text-4xl font-bold tracking-tight text-gray-900">{tier.price[frequency.value]}</span>
                  <span className="text-sm font-semibold leading-6 text-gray-600">{frequency.priceSuffix}</span>
                </p>
                <button
                  onClick={() => setOpen(true)}
                  aria-describedby={tier.id}
                  className={classNames(
                    tier.mostPopular
                      ? 'bg-red-600 text-white shadow-sm hover:bg-red-500'
                      : 'text-red-600 ring-1 ring-inset ring-red-200 hover:ring-red-300',
                    'mt-6 block w-full rounded-md px-3 py-2 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
                  )}
                >
                  Currently Unavailable
                </button>
                <ul className="mt-8 space-y-3 text-sm leading-6 text-gray-600">
                  {tier.features.map((feature) => (
                    <li key={feature} className="flex gap-x-3">
                      <CheckIcon aria-hidden="true" className="h-6 w-5 flex-none text-red-600" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-50">
        <div className="mx-auto max-w-2xl px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:px-8">
            
            
            {/* Details section */}
            <section aria-labelledby="details-heading">
            <div className="flex flex-col items-center text-center">
                <h2 id="details-heading" className="mt-2 text-3xl font-bold tracking-tight text-gray-700">
                The Fine Details
                </h2>
                <p className="mt-3 max-w-5xl text-lg text-gray-600">
                We offer a total package of professional car detailing services. These services include thorough cleaning, washing, polishing and paint protection applications. Always with the aim of bringing your car back to absolute showroom condition, while providing our customers with great prices and service quality.
                </p>
            </div>

            
            </section>
        </div>
        </div>
      </main>

      <Dialog open={open} onClose={setOpen} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div>
                  <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
                    <BellAlertIcon aria-hidden="true" className="size-6 text-red-600" />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                      Service Unavailable during Winter
                    </DialogTitle>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        This service is currently unavailable during the winter season. Please contact us for more information.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="inline-flex w-full justify-center rounded-md bg-slate-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600"
                  >
                    Back to Auto Detailing
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
        
        <FooterAts />
        </div>
    );
};

export default Detailing;